import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import CustomSelect from "../../component/CustomSelect";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const updateEndpoint = ApiEndpoints.job.Update;
const editEndpoint = ApiEndpoints.job.Edit;
const locListEndpoint = ApiEndpoints.loc.List;
const depListEndpoint = ApiEndpoints.operation.List;
const expListEndpoint = ApiEndpoints.exp.List;


export default function AddJobPosting() {
  const navigate = useNavigate();
  const {job_id} = useParams();

  const [dropData, setDropData] = useState({
    experiences: [],
    locations: [],
    departments: []
  });

  const [postData, setPostData] = useState({ 
    title:"",
    department_id:"",
    location_id:"",
    experience_id:"",
    type:"",
    date: new Date(),
    job_description:"",
    qualifications:"",
    skills:"",
    additional_information:"",
    slug:"",
   });

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [expRes, depRes, locRes,jobRes] = await Promise.all([
          ApiRequest("GET", expListEndpoint),
          ApiRequest("GET", depListEndpoint),
          ApiRequest("GET", locListEndpoint),
          ApiRequest("GET", editEndpoint + job_id),
        ]);

        setDropData({
          experiences: expRes?.experiences || [],
          departments: depRes?.departments || [],
          locations: locRes?.locations || [],
        });

        setPostData(jobRes.job);
      } catch (error) {
        console.error("Failed to fetch data:", error);
        setDropData({ experiences: [], departments: [], locations: [] });
      }
    };

    fetchAll();
  }, [job_id]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setPostData((prev) => ({
      ...prev,
      job_id: job_id,
      [name]: value,
    }));
  };


  const handleEditorChange = (key, data) => {
    setPostData((prevState) => ({
      ...prevState,
      [key]: data,
    }));
  };


  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const [key, value] of Object.entries(postData)) {
      if (value === "" || value === null) {
        toast.error(`The field "${key}" is mandatory.`);
        return;
      }
    }

    try {
      const payload = {
      ...postData,
        job_id,
      date: new Date(postData.date), // 🔹 Convert here
    };
      const response = await ApiRequest("POST", updateEndpoint, payload);
      if(response.error !== true){
        toast.success(response.message);
        navigate("/jobpost");
      }else{
        toast.error(response.message)
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const pagename = {
    name: 'Job Management',
    user: 'Admin',
    innerpage: 'Job Management / Job Posting / Edit Job'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <form id="blogAdd" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="title" value={postData.title} type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>slug<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="slug" value={postData.slug} type="text" className="form-control" placeholder="Enter Slug" />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Department<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} defaultValue={postData.department_id} name={"department_id"} options={dropData.departments} placeholder="Select Department" />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Location<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name={"location_id"} defaultValue={postData.location_id} options={dropData.locations} placeholder="Select Location" />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Experience<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name={"experience_id"} defaultValue={postData.experience_id} options={dropData.experiences} placeholder="Select Experience " />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Type<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name={"type"} defaultValue={postData.type}
                  options={[{_id:"full time", name:"full time"}, {_id:"part time", name:"part time"}]} 
                  placeholder="Select Type " />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Date<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="date" type="date" className="form-control" placeholder="select date" value={postData.date}/>
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Job Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.job_description} onChange={(event, editor) => handleEditorChange("job_description", editor.getData())} />
                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Qualifications<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.qualifications} onChange={(event, editor) => handleEditorChange("qualifications", editor.getData())} />
                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Skills <small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.skills} onChange={(event, editor) => handleEditorChange("skills", editor.getData())} />
                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Additional Information <small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.additional_information} onChange={(event, editor) => handleEditorChange("additional_information", editor.getData())} />
                </div>
              </div>
            </div>
          </div>
        </form>
        <button type="submit" form="blogAdd" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}
